import { Product } from '../services/departures'
import { Market } from '../types/booking'

export function priceMultiplier (calculation: Product['price_calculation'], days: number): number {
  switch (calculation) {
    case 'per_day':
      return days
    case 'per_night':
      return days - 1
    case null:
      return 1
  }
}

export function hasSGR (market: Market): boolean {
  return market !== 'north_america' && market !== 'kootstra'
}

export function hasVAT (market: Market): boolean {
  return market !== 'north_america' && market !== 'kootstra'
}
